import type { FC } from "react";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";

type Props = {
  handleOnMenu: () => void;
};

const Header: FC<Props> = ({ handleOnMenu }) => {
  const { t } = useTranslation();
  return (
    <div className="h-(--height-header) w-full sm:w-full bg-[#FCFCFC] sm:bg-[white] flex items-center justify-between sm:justify-end px-[24px] z-2 sm:z-1">
      <div className="sm:hidden flex items-center gap-[16px]">
        <Button variant="secondaryFilled" size="icon" onClick={handleOnMenu}>
          <Menu height={24} width={24} color="#44546F" />
        </Button>
        <img alt="krunsh logo" src={"/svg/krunsh.svg"} />
      </div>
      <div className="flex gap-[12px] items-center">
        <Link to={"sign-up"}>
          <Button>{t("start_with_krunsh")}</Button>
        </Link>
      </div>
    </div>
  );
};

export default Header;
